import React, {Component} from 'react';
import {Provider} from 'react-redux';
import {store} from './redux/store';
import TagManager from 'react-gtm-module';
import Boot from './redux/boot';
import ConnectedDashApp from "./dashAppConnected";

class DashApp extends Component {
    constructor(props) {
        super(props);

        // GTM
        const gtmArgs = {
            gtmId: process.env.REACT_APP_GTM_ID,
        };
        TagManager.initialize(gtmArgs);
    }

    render() {
        return (
            <Provider store={store}>
                <ConnectedDashApp />
            </Provider>
        );
    }
}

Boot()
    .then(() => <DashApp />)
    .catch(error => console.error(error));

export default DashApp;
